import type { AxiosResponse } from 'axios';
import type { ServiceType } from '@app-types/models/plan';
import api from './api';

interface OnboardingResponse {
  success: boolean;
  [key: string]: unknown;
}

interface ServiceTypesResponse {
  serviceTypes: ServiceType[];
  [key: string]: unknown;
}

interface UpdatePhoneResponse {
  success: boolean;
  [key: string]: unknown;
}

export const onboardingSubmit = async (formData: FormData): Promise<OnboardingResponse | unknown> => {
  try {
    const response: AxiosResponse<OnboardingResponse> = await api.post('/onboarding', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    console.log('Onboarding form submitted successfully:', response.data);
    return response.data;
  } catch (error: unknown) {
    console.error('Error submitting onboarding form:', error);
    return error;
  }
};

export const getServiceTypes = async (): Promise<ServiceTypesResponse> => {
  try {
    const response: AxiosResponse<ServiceTypesResponse> = await api.get('/onboarding/service-types');
    console.log('Fetched service types:', response.data);
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching service types:', error);
    throw error;
  }
};

export const updatePhoneNumber = async (email: string, phoneNumber: string): Promise<UpdatePhoneResponse> => {
  try {
    const response: AxiosResponse<UpdatePhoneResponse> = await api.post('/onboarding/update-phone', {
      email,
      phoneNumber
    });
    console.log('Phone number updated successfully:', response.data);
    return response.data;
  } catch (error: unknown) {
    console.error('Error updating phone number:', error);
    throw error;
  }
};
